import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';
import type { TaskStatus } from '@/lib/schemas';

/**
 * מקור יחיד לתרגום ולצבע של סטטוס. מיפוי מפוזר ב-JSX הוא איך
 * ש"בטיפול" מופיע בשלושה גוונים בשלושה מסכים.
 */
const STATUS = {
  NEW: { labelKey: 'status.new', tone: 'info' },
  ASSIGNED: { labelKey: 'status.assigned', tone: 'accent' as 'info' },
  IN_PROGRESS: { labelKey: 'status.inProgress', tone: 'warning' },
  CLOSED: { labelKey: 'status.closed', tone: 'success' },
  CANCELLED: { labelKey: 'status.cancelled', tone: 'neutral' },
} as const satisfies Record<TaskStatus, { labelKey: string; tone: 'neutral' | 'info' | 'warning' | 'success' | 'danger' }>;

export function TaskStatusBadge({ status }: { status: TaskStatus }) {
  const { t } = useTranslation('tasks');
  const s = STATUS[status];
  return <Badge tone={s.tone}>{t(s.labelKey)}</Badge>;
}

/** מפתח התרגום (ב-namespace ‏tasks) של הסטטוס. */
export const statusLabelKey = (s: TaskStatus) => STATUS[s].labelKey;

const PRIORITY = {
  1: { labelKey: 'priority.urgent', tone: 'danger' },
  2: { labelKey: 'priority.normal', tone: 'neutral' },
  3: { labelKey: 'priority.low', tone: 'info' },
} as const satisfies Record<number, { labelKey: string; tone: 'danger' | 'neutral' | 'info' }>;

export function PriorityBadge({ priority }: { priority: number }) {
  const { t } = useTranslation('tasks');
  const p = PRIORITY[priority as keyof typeof PRIORITY] ?? PRIORITY[2];
  return (
    <Badge tone={p.tone} dot={priority === 1}>
      {t(p.labelKey)}
    </Badge>
  );
}
